import ptLocale from 'element-ui/lib/locale/lang/pt' //引入element语言包
const pt = {
  posterPage: {
    title1:'Subscrição está pronto!',
    title2:'Subscrição renovada, upgrade privilegiado!',
    title3:'Desconto exclusivo, renovação mais econômica',
    title4:'Obter o código de resgate, você pode consultar o vendedor que comprou o equipamento',
    title5:'Funções de experiência prioritárias',
    function1:'Detalhes da função:',
    function2:'Renovação de serviços básicos (tradução simultânea, assistente de conferência, assistente inteligente)...',
    function3:'Subscrição de serviços de valor agregado (tradução offline, tradução de chamadas de áudio e vídeo)...',
  },
  RedemptionCodePage: {
    RedemptionCode: 'Código de reembolso',
    ValueAddedServices: 'serviços de valor acrescentado',
    UpgradedExperience: 'Benefícios exclusivos de valor acrescentado, experiência melhorada',
    OfflineTranslation: 'Tradução offline',
    NoInternet: 'Não há necessidade de conexão com a Internet, tradução instantânea, segura e confiável',
    GoToSubscribe: 'Ir subscrever',
    AudioAndVideoCall: 'Chamada de áudio/vídeo',
    RealTimeCall: 'Tradução vocal em tempo real e acessibilidade à comunicação',
    BaseService: 'Serviços básicos',
    AIAssistant: 'Funções: interpretação simultânea, assistente de conferência, assistente de IA',
    LanguagesSetting:'Configurações de idioma',
    languages1:'Chinês simplificado',
    languages2:'Chinês Tradicional',
    languages3:'Inglês',
    languages4:'japonês',
    languages5:'Coreano',
    languages6:'russo',
    languages7:'Espanhol',
    languages8:'Francês',
    languages9:'alemão',
    languages10:'Português',
    languages11:'Italiano',
    languages12:'Turco',
    languages13:'Vietnês',
    languages14:'Indonésia',
    languages15:'Hindi',
    languages16:'Árabe',
    languages17:'Tailandês',
    languages18:'Persa',
  },
  Login: {
    ToLogin: 'iniciar sessão',
    PhoneLogin: 'Iniciar sessão com o número de telefone',
    EmailLogin: 'Login de e- mail',
    PhonePlaceholder: 'Introduza o seu número de telefone',
    EmailPlaceholder: 'Enter email',
    Code: 'Código de verificação',
    and: 'e',
    BeforeText: 'Criar uma conta representa seu acordo e conformidade',
    UserAgreement: 'Acordo do Utilizador',
    privacy: 'Política de Privacidade',
    errorMessage: 'Erro no código de verificação',
    readTitle: 'Leia e concorde com o seguinte acordo',
    readBefore: 'Para garantir a segurança de suas informações pessoais, leia e concorde primeiro',
    cancel: 'cancelar',
    agree: 'Concordar e continuar',
    error1:'Por favor, insira um endereço de e-mail válido',
    error2:'Digite o número correto',
    error3:'Por favor, insira o código de verificação',
    success:'Login com sucesso'
  },
  OffLinePage: {
    title: 'Tradução offline',
    NoInternet: 'Não há necessidade de conexão com a Internet, tradução instantânea, segura e confiável',
    ServiceLife: 'vida útil',
    forever: 'Utilização Permanente',
    describe: 'Instruções de Assinatura',
    describeItem1: '1. A função de tradução offline é um pagamento único, uso permanente, e a permissão de uso segue o dispositivo Bluetooth. Se você alterar o dispositivo, você precisa assinar o código de resgate de tradução offline novamente.',
    describeItem2: '2. A assinatura do código de autorização não é reembolsável.',
    describeItem3: '3. Suporta 10 idiomas: chinês, inglês, alemão, japonês, coreano, hindi, tailandês, espanhol, francês, russo.',
    quantity: 'Quantidade',
    payType: 'Forma de pagamento',
    card: 'Cartão Bancário',
    wx: 'WeChat',
    GooglePay: 'Google Pay',
    subscribe: 'subscrever',
    RMB: '¥',
    confirm:'confirmar',
    cardNumber:'Número do cartão',
    periodOfValidity:'período de validade',
    safetyCode:'Código de segurança',
    name:'Nome completo',
    yearAndMonth:'Ano/Mês',
    message1:'O número não pode ser 0.',
    popTip:'Conselhos',
    popText1:'Por favor, leia com atenção e compreenda.',
    popText2:'Contrato de pagamento de tradução offline',
    popText3:'Li e concordo',
    popText4:'Li e concordou',
  },
  AudioVideoPage: {
    title: 'Chamada de áudio/vídeo',
    RealTime: 'Tradução vocal em tempo real e acessibilidade à comunicação',
    describe: 'Instruções de Assinatura',
    describeItem1: '1. A função de tradução de chamadas de áudio e vídeo é recarregar e comprar minutos. Os minutos contam a partir do momento em que a chamada é conectada, e as permissões seguem a conta. Se você entrar em outra conta, você precisa recarregar novamente.',
    describeItem2: '2. Depois de recarregar a conta, conectar e vincular dispositivos diferentes ainda podem ser usados como de costume.',
    describeItem3: '3. A função de tradução de chamadas de áudio e vídeo não pode ser reembolsada após a recarga.',
    payType: 'Forma de pagamento',
    card: 'Cartão Bancário',
    wx: 'WeChat',
    GooglePay: 'Google Pay',
    subscribe: 'subscrever',
    RMB: '¥',
    sale: 'desconto',
    confirm:'confirmar',
    time1:'segundos',
    time2:'minutos',
    time3:'Horas',
    time4:'Dia',
    time5:'mês',
    time6:'ano',
  },
  OffLineResult: {
    title1: "Tradução offline",
    title2: 'Chamada de áudio/vídeo',
    title3: 'Serviços básicos',
    success: 'Assinatura bem sucedida',
    fail: 'A assinatura falhou',
    stock:'Código de troca em stock',
    saveTitle: 'Salve o código de resgate e vá para o aplicativo para resgatá-lo',
    code: 'Código de reembolso',
    tip1: 'Este código é usado apenas para resgatar a função de tradução offline',
    tip2: 'Este código é usado apenas para resgatar a função de tradução de chamadas de áudio/vídeo',
    tip3: 'Este código é usado apenas para resgatar funções básicas de renovação de serviço',
    save: 'salvar',
    time: 'Tempo de subscrição:',
    copy: 'cópia',
    copySuccess: 'Replicar o Sucesso',
    loading:'Carregando',
    paySuccess:'Pagamento bem sucedido'
  },
  RedemptionList: {
    title: 'O meu código de resgate',
    view: 'vista',
    time: 'Tempo de subscrição:',
  },
  MyRedemption: {
    title: 'O meu código de resgate',
    code: 'Código de reembolso',
    time: 'Tempo de subscrição:',
    copy: 'cópia',
    tip1: 'Este código é usado apenas para resgatar a função de tradução offline',
    tip2: 'Este código é usado apenas para resgatar a função de tradução de chamadas de áudio/vídeo',
    tip3: 'Este código é usado apenas para resgatar funções básicas de renovação de serviço',
    save: 'salvar',
    success:"Operação bem sucedida"
  },
  basePage:{
    error1:'Nenhuma informação do produto',
    message1:'Selecione um produto',
    title:'Serviços básicos',
    function:'Funções: interpretação simultânea, assistente de conferência, assistente de IA',
    describe: 'Instruções de Assinatura',
    describe1:'1. Após a renovação dos serviços básicos, como tradução de interpretação simultânea e assistente de conferência, o período de validade segue o equipamento. Se o equipamento for substituído, ele precisa ser renovado.',
    describe2:'2. Os serviços básicos não podem ser reembolsados após renovação.',
    payType: 'Forma de pagamento',
    card: 'Cartão Bancário',
    wx: 'WeChat',
    GooglePay: 'Google Pay',
    subscribe: 'subscrever',
    RMB: '¥',
    sale: 'desconto',
    month:'a lua',
    confirm:'confirmar',
    month1:'1 mês',
    month2:'Meio ano',
    month3:'1 ano'
  },
  ...ptLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default pt;
